module.exports = __webpack_public_path__ + "static/media/trip-orange.c30edcf1.svg";